import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  usersContainer: {
    height: '100%',
    position: 'relative',
    paddingRight: 16,

    '& .users-search': {
      display: 'flex',
      alignItems: 'center',
      height: 'auto',
      boxShadow: '0 0 15px 0px rgb(111 72 65 / 0.15)',
      borderRadius: 8,
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      '& p': {
        color: '#513628',
        fontSize: 16,
        margin: '6px 0 0 8px'
      },
      '& button': {
        height: 35,
        margin: '0 8px 0 0',
        width: 'auto',
        minWidth: 150,
        '& img': {
          marginRight: 8
        }
      },
      '& i': {
        marginRight: 8,
        border: '0.10em solid #513628',
        borderTop: 'none',
        borderLeft: 'none',
        padding: 3,
        background: '#fff'
      },
      '& input': {
        width: '75%',
        height: 16,
        fontSize: 16,
        margin: '16px 0 8px 8px',
        borderTop: 'none',
        borderLeft: 'none',
        borderRight: 'none',
        border: '0.10em solid #513628',
        '&:focus': {
          outline: 0
        },
      },
      '@media (min-width:400px)': {
      }
    },
  },

  usersHeader: {
    display: 'block',
    width: '100%',
    alignItems: 'center',
    paddingRight: 16,
    '@media (min-width:436px)': {
      paddingRight: 0,
      display: 'inline-flex',
    }
  },

  usersButtonContainer: {
    marginLeft: 'auto',
    width: '100%',
    '& button': {
      width: '100%',
      margin: '8px 16px 16px 0',
      '& img': {
        marginRight: 8
      }
    },
    '@media (min-width:436px)': {
      width: 'unset',
      '& button': {
        width: 146,
        margin: '0 16px 0 0',
        '& img': {
          marginRight: 8
        }
      },
    }
  },

  usersDivider: {
    width: '25%',
    // display: 'none',
    '@media (min-width:436px)': {
      // display: 'unset',
    }
  },

  usersTitle: {
    width: 100,
    color: theme.palette.primary.main,
    fontSize: theme.app.typography.subTitle.fontSize,
    fontWeight: theme.app.typography.subTitle.fontWeight,
    '@media (max-width:400px)': {
      marginBottom: 8,
    }
  },

  usersTableActions: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-around',
    height: 5,
    '& img': {
      cursor: 'pointer',
    },
    '& .users__deleteIcon': {
      height: 16,
      marginTop: '-5px',
      color: '#513628'
    },
  },

  usersPopup: {
    '& .popup__box': {
      height: 'auto',
      '@media (max-width:565px)': {
        height: '80vh',
      },
    },
  },

  usersPopupDialog: {
    '& .popup__box': {
      height: 'auto',
      width: 400,
    },
  },

  salesHeaderContent: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',

    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'start'
    }
  },

  salesHeaderBtnContainer: {
    display: 'flex',
    alignItems: 'center',

    '& :nth-child(2)': {
      width: 139,
      marginLeft: 16
    },

    [theme.breakpoints.down('sm')]: {
      padding: '16px 0',
      flexWrap: 'wrap'
    }
  },

  salesHeader: {
    display: 'block',
    width: '100%',
    alignItems: 'center',
    paddingRight: 16,
    '@media (min-width:356px)': {
      paddingRight: 16,
      display: 'inline-flex'
    }
  },

  buttonContainer: {
    display: 'flex',
    gap: '10px',
    marginBottom: '-2px',
    paddingLeft: '10px',
    zIndex: 1,
    [theme.breakpoints.down('sm')]: {
      paddingLeft: '0',
      marginTop: '8px',
      flexDirection: 'column',
      width: '100%'
    }
  },

  buttonOutlined: {
    backgroundColor: 'transparent',
    border: `1px solid ${theme.palette.primary.main}`,
    color: theme.palette.primary.main
  },

  buttonWrapper: {
    width: 'max-content',
    display: 'flex',
    padding: '8px 16px 8px 12px',
    gap: '8px',

    [theme.breakpoints.down('sm')]: {
      width: '100%',
    }
  },
}))
